import React from 'react';
import {Container, Grid, Paper, Typography} from "@mui/material";
// import PrimaryButton from "../../Common/PrimaryButton";
import {styled} from '@mui/material/styles';

const PREFIX = 'ReservedRoom';
const classes = {
    root: `${PREFIX}-root`,
    roomName: `${PREFIX}-roomName`,
    berths: `${PREFIX}-berths`,
    roomContainer: `${PREFIX}-roomContainer`,
    roomImage: `${PREFIX}-roomImage`,
    upgradeBanner: `${PREFIX}-upgradeBanner`,
    upgradeTitle: `${PREFIX}-upgradeTitle`,
    upgradeDescription: `${PREFIX}-upgradeDescription`,
}
const Root = styled('div')(({theme}) => ({
    [`&.${classes.root}`]: {
        // marginTop: '50px'
        width: '100%',
    },
    [`& .${classes.roomName}`]: {
        fontSize: '2.4rem',
        fontWeight: 600,
        textAlign: 'left',
        marginBottom: '10px',
    },
    [`& .${classes.berths}`]: {
        fontSize: '1.6rem',
        fontWeight: 600,
        marginTop: '10px',
    },
    [`& .${classes.roomContainer}`]: {
        marginTop: '30px',
    },
    [`& .${classes.roomImage}`]: {
        height: '100%',
        objectFit: 'cover',
        maxHeight: '300px',
    },
    [`& .${classes.upgradeBanner}`]: {
        marginTop: '30px',
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        borderRadius: 0,
    },
    [`& .${classes.upgradeTitle}`]: {
        fontSize: '2.4rem',
        fontWeight: 600,
        marginBottom: '20px',
        letterSpacing: '1.2px',
    },
    [`& .${classes.upgradeDescription}`]: {
        fontSize: '1.6rem',
        fontWeight: 400,
        textAlign: 'left',
    },
}))

const ReservedRoom = ({room}) => {
    return (
        <Root className={classes.root}>
            <Paper style={{marginTop: '20px'}} elevation={3}>
                <Grid container>
                    <Grid item xs={12} md={3}>
                        <img className={classes.roomImage} src={`${room.image}`} alt={room.title}/>
                    </Grid>
                    <Grid item xs={12} md={9}>
                        <Container className={classes.roomContainer}>
                            <div style={{marginLeft: '10px', marginRight: '20px'}}>
                                <Typography variant={'h4'} className={classes.roomName} dangerouslySetInnerHTML={{__html: room.title}}/>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={9}>
                                        <Typography>{room.description}</Typography>
                                        <Typography variant={'h5'} className={classes.berths}>{room.count} {room.count > 1 ? 'berths' : 'berth'} reserved.</Typography>
                                        <br/>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                            {/*<PrimaryButton style={{margin: 0}}>Update</PrimaryButton>*/}
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </Container>
                    </Grid>
                </Grid>
            </Paper>

            {/*<Paper className={classes.upgradeBanner}>
                <Grid container>
                    <Grid item xs={12} md={2}>
                        <img src={`${window['siteUrl']}/images/room-pictures/NBA/Superior-1.jpg`} alt={'Stateroom'}/>
                    </Grid>
                    <Grid item xs={12} md={10}>
                        <Container style={{height: '100%'}}>
                            <Grid container style={{height: '100%'}}>
                                <Grid item xs={12} md={8}>
                                    <div style={{marginTop: '20px', marginLeft: '10px'}}>
                                        <Typography variant={'h3'} className={classes.upgradeTitle}>Upgrade to Superior
                                            Suite for only $XX!</Typography>
                                        <Typography variant={'h4'} className={classes.upgradeDescription}>Stay as if
                                            you’re in a nice hotel room.</Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%'
                                    }}>
                                        <PrimaryButton style={{width: 'auto'}}>Upgrade your room</PrimaryButton>
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
            </Paper>*/}
        </Root>
    );
};

export default ReservedRoom;